export const T = {
  en_GB: {
    tools: (n: number) => `${n} tool${n !== 1 ? "s" : ""}`,
    running: (n: number) => ` (${n} running)`,
    details: "Input and output details for this tool call.",
    input: "Input",
    output: "Output",
    copy: "Copy",
    copyAll: "Copy all",
    copied: "Copied",
  },
  nb_NO: {
    tools: (n: number) => `${n} verktøy`,
    running: (n: number) => ` (${n} kjører)`,
    details: "Inndata og utdata for dette verktøykallet.",
    input: "Inndata",
    output: "Utdata",
    copy: "Kopier",
    copyAll: "Kopier alt",
    copied: "Kopiert",
  },
} as const;
